import { SigningContext } from './signingContext';

export enum SigningStep {
    CheckingCertificate = "CheckingCertificate",
    GettingHash = "GettingHash",
    Signing = "Signing",
    SavingCertificate = "SavingCertificate",
    Sending = "Sending",
    Completed = "Completed",
}

export const SigningStepUtil = {
    getMessage: (step: SigningStep, context?: SigningContext): string => {
        switch (step) {
            case SigningStep.CheckingCertificate:
                return "Проверка сертификата...";
            case SigningStep.Signing:
            case SigningStep.Sending:
            case SigningStep.GettingHash:
            case SigningStep.SavingCertificate:
                return context === SigningContext.SignerService
                    ? "Подписание облачным токеном..."
                    : "Подписание физическим токеном...";
            case SigningStep.Completed:
                return "Успешное подписание!";
            default:
                return "";
        }
    }
};

